<ng-template #middleOfficeButtons>
  @if (isMiddleOfficeAvailable()) {
    <app-button-middle-office styleClass="pb-2.5" type="EDIT_REALISATION" />
    <app-button-middle-office styleClass="pb-2.5" type="ADD_REALISATION" />
  }
</ng-template>

@if (projects().length > 0) {
  <section class="-my-9 w-screen py-9 desk:w-auto">
    <div class="mask-curve-top-div bg-gray-light"></div>
    <div class="bg-gray-light py-9">
      <div class="desk:centered-with-padding">
        <div class="mb-8 px-5 desk:px-0">
          <app-title [title]="data.title" size="h2" />
        </div>
        <div class="relative h-64 w-full desk:h-96 desk:px-14">
          <div class="relative size-full">
            <div
              #slidesElementRef
              class="no-scrollbar flex size-full snap-x snap-mandatory gap-x-2 overflow-x-scroll scroll-smooth px-5 desk:px-0">
              @for (project of projects(); track $index) {
                <div
                  (click)="openRealisationsClientsPopup($index)"
                  [ngClass]="{ 'snap-x-start': $index % 2 === 1 }"
                  class="group relative h-full w-80 shrink-0 cursor-pointer overflow-hidden rounded-[25px] desk:w-[calc(50%-4px)]">
                  <app-image
                    [hoverEffect]="true"
                    [image]="project.images[0]"
                    [isPriority]="!isImageInPreviousBlocks && $index < 2" />
                  <div class="absolute inset-0 bg-gradient-to-b from-transparent to-black/50"></div>
                  <div class="absolute bottom-0 flex w-full items-center justify-between p-5">
                    <span class="max-w-96 font-title text-[18px] font-normal leading-5 tracking-[-0.36px] text-white">{{
                      project.name
                    }}</span>
                    <app-svg [inline]="true" [width]="24" class="text-white" src="assets/icons/arrow-right.svg" />
                  </div>
                </div>
              }
            </div>
            <!-- Controls -->
            <button class="absolute left-0 top-1/2 hidden -translate-x-1/2 -translate-y-1/2 desk:block">
              <div
                (click)="moveSlider('prev')"
                class="drop-shadow-custom flex size-8 items-center justify-center rounded-lg bg-white">
                <app-svg [width]="24" class="block rotate-180" src="assets/icons/arrow-right.svg" />
              </div>
            </button>
            <button class="absolute right-0 top-1/2 hidden -translate-y-1/2 translate-x-1/2 desk:block">
              <div
                (click)="moveSlider('next')"
                class="drop-shadow-custom flex size-8 items-center justify-center rounded-lg bg-white">
                <app-svg [width]="24" src="assets/icons/arrow-right.svg" />
              </div>
            </button>
          </div>
        </div>
        <div class="mx-auto mt-6 flex w-fit flex-col items-center">
          <div class="flex gap-x-2.5">
            <ng-container *ngTemplateOutlet="middleOfficeButtons" />
          </div>
          <app-button [label]="data.cta.label" [url]="data.cta.url"></app-button>
        </div>
      </div>
    </div>
    <div class="mask-curve-bottom-div bg-gray-light"></div>
  </section>
} @else if (isMiddleOfficeAvailable()) {
  <div class="centered-with-padding py-7">
    <div class="mb-4">
      <app-title [title]="data.title" size="h2" />
    </div>
    <div class="flex justify-center gap-x-2.5">
      <ng-container *ngTemplateOutlet="middleOfficeButtons" />
    </div>
  </div>
}
